export default __webpack_public_path__ + "static/media/strasbourgmini.d1d659a1.jpg";